import { Alert, BackIcon, Box, Button, ForwardIcon, Link, Typography } from "@carrotfertility/carotene-core"
import React from "react"
import { Link as RouterLink } from "react-router-dom"
import { BookingBreadcrumbs } from "../Breadcrumbs"
import { BookingCard } from "./BookingCard"

export type SupportPhone = { display: string; e164: string }

type BookingRecoveryNoticeProps = {
  heading: string
  children?: React.ReactNode
  actions: React.ReactNode
}

function BookingRecoveryNotice({ heading, children, actions }: BookingRecoveryNoticeProps): JSX.Element {
  return (
    <Box sx={(theme) => ({ display: "flex", flexDirection: "column", gap: theme.spacing(theme.tokens.spacing.sm) })}>
      <BookingBreadcrumbs />
      <BookingCard>
        <Alert severity="error">We weren&rsquo;t able to book this appointment</Alert>
        <Typography variant="h2" component="h1">
          {heading}
        </Typography>
        {children && <Typography variant="body1">{children}</Typography>}
        <Box
          sx={(theme) => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: theme.spacing(theme.tokens.spacing.sm)
          })}
        >
          {actions}
        </Box>
      </BookingCard>
    </Box>
  )
}

export function ChooseNewSlotPage({ onContinue, onBack }: { onContinue: () => void; onBack: () => void }): JSX.Element {
  return (
    <BookingRecoveryNotice
      heading="Please try choosing a time again"
      actions={
        <>
          <Button color="secondary" variant="text" startIcon={<BackIcon />} onClick={onBack}>
            Back
          </Button>
          <Button color="secondary" endIcon={<ForwardIcon />} onClick={onContinue}>
            Continue
          </Button>
        </>
      }
    >
      If you continue having problems,{" "}
      <Link component={RouterLink} to="/messages">
        send us a message
      </Link>
      .
    </BookingRecoveryNotice>
  )
}

export function BookingSupportPage({ supportPhone }: { supportPhone?: SupportPhone }): JSX.Element {
  return (
    <BookingRecoveryNotice
      heading="Please contact us for assistance"
      actions={
        <>
          <Button component={RouterLink} to="/care-team" color="secondary" variant="text" startIcon={<BackIcon />}>
            Back to Care Team
          </Button>
          <Button component={RouterLink} to="/messages" variant="contained" color="secondary">
            Send a message
          </Button>
        </>
      }
    >
      {supportPhone ? (
        <>
          Call us at <Link href={`tel:${supportPhone.e164}`}>{supportPhone.display}</Link> or send a message.
        </>
      ) : null}
    </BookingRecoveryNotice>
  )
}
